import * as React from "react";
import { forwardRef } from "react";
const SvgSpinnerLarge = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { className: "spinner", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { className: "path", fill: "none", strokeWidth: 6, strokeLinecap: "round", cx: 50, cy: 50, r: 45 }));
const ForwardRef = forwardRef(SvgSpinnerLarge);
export { ForwardRef as ReactComponent };
